export default async function GetTopPlansApi(id, positionId, page, sortOption, LIMIT_PER_PAGE) {
  let res = "";
  try {
    const body = {
      performanceCycle: id,
      positionId: positionId,
      startAt: page,
      limit: LIMIT_PER_PAGE,
      sortOption: sortOption,
    };
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/top-plans`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error getting unit table: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
